import { fetchBasicJsonPost } from '@/script/common';

export default {
    changePassword: (oldPass, newPass) =>
        fetchBasicJsonPost('/UserProfile/Save', {
            data: {
                password: oldPass,
                new_password: newPass
            }
        })
};